import {appAPI} from "../../../api";
import {INewTechnicalLiterature, ITechnicalLiterature} from "../../../models/ITechnicalLiterature";

const technicalLiteraturePath = `/technical_literature`;

export const technicalLiteratureAPI = {
    // 1. Получить presigned URL для прямой загрузки в S3
    getUploadUrl: async (file_name: string, content_type: string): Promise<{ upload_url: string; s3_key: string }> => {
        const res = await appAPI.post(`${technicalLiteraturePath}/upload-url`, {
            file_name,
            content_type,
        });
        return res.data;
    },

    // 2. Получить временную ссылку на скачивание
    getDownloadUrl: async (id: string): Promise<{ url: string }> => {
        const res = await appAPI.get(`${technicalLiteraturePath}/${id}/download`);
        return res.data;
    },

    add: async (literature: INewTechnicalLiterature) => {
        try {
            const res = await appAPI.post(
                technicalLiteraturePath,
                {
                    ...literature,
                    year_from: +literature.year_from || 0,
                    year_to: +literature.year_to || 0,
                    engine_type_ids: literature.engine_type_ids.map(item => Number(item)),
                    file_size: +literature.file_size || 0,
                    pages: Number(literature?.pages || 0),
                });
            return res.data;
        } catch (error: any) {
            const message =
                error.response?.data?.message ||
                error.response?.data?.detail ||
                `Ошибка сервера: ${error.response?.status} ${error.response?.statusText}`;
            throw new Error(message);
        }
    },
    getAll: async () => {
        const res = await appAPI.get(technicalLiteraturePath);
        return res.data;
    },
    update: async (literature: ITechnicalLiterature) => {
        try {
            const res = await appAPI.put(`${technicalLiteraturePath}/${literature.id}/`, {
                ...literature,
                year_from: +literature.year_from || 0,
                year_to: +literature.year_to || 0,
                file_size: +literature.file_size || 0,
                engine_type_ids: literature.engine_type_ids.map(item => Number(item)),
                pages: Number(literature?.pages || 0),
            });
            return res.data;
        } catch (error: any) {
            const message =
                error.response?.data?.message ||
                error.response?.data?.detail ||
                `Ошибка сервера: ${error.response?.status} ${error.response?.statusText}`;
            throw new Error(message);
        }
    },
    delete: async (id: string) => {
        const res = await appAPI.delete(`${technicalLiteraturePath}/${id}`);
        return res.data;
    },

    // Публикация документа на лендинге — только для админа (@AdminOnly на бэке).
    // Тела нет: заголовок и адрес страницы бэкенд собирает сам. Ошибка (файл
    // не PDF) приходит текстом в message и показывается как есть.
    publish: async (id: string) => {
        const res = await appAPI.post(`${technicalLiteraturePath}/${id}/publish`, {});
        return res.data;
    },
    unpublish: async (id: string) => {
        const res = await appAPI.post(`${technicalLiteraturePath}/${id}/unpublish`, {});
        return res.data;
    },
};